import { defineAsyncComponent } from 'vue'
export default {
  dashboard: defineAsyncComponent(() => import("/app/src/layouts/dashboard.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/src/layouts/default.vue").then(m => m.default || m)),
  public: defineAsyncComponent(() => import("/app/src/layouts/public.vue").then(m => m.default || m))
}